module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-002"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("YOUNG JEREMIAH’S CALL TO THE NATIONS"), _c('br'), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Jeremiah+1%3A6-10&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("JEREMIAH 1:6-10")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW:")])]), _vm._v("Jeremiah attempted to humbly decline his position from God (E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USEBIUS, ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AZIANZUS")]), _vm._v("), as Moses did, but modesty is no reason to decline the grace of a divine call (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v("). Jeremiah was able to excuse himself from ministry because God does not force anyone to accept his call (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). But before accepting, a minister should realize that the yoke of the Word of preaching is heavy, as Jeremiah said (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v("). Jeremiah had a specific, special calling from God (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). The Lord liberates one who suffers in order to overcome tribulations (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Jeremiah received the word of God, which was shown to be hot and fiery (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). He uttered the word put into his mouth by God (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTULLIAN")]), _vm._v("). Jeremiah and the prophets spoke by prophetic inspiration (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). The grace bestowed on Jeremiah is in every age bestowed on the church to prevail over heresy (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOPHILUS")]), _vm._v("). We may pray for the word to be given to us as it was to Jeremiah (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). The word given to him was a word of judgment, which must work much harder at destroying sin in the body by uprooting, pulling down, wasting and destroying than building and planting virtue (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASSIAN")]), _vm._v("). That the Lord destroys in order to rebuild is figurative of his people (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("). Jeremiah proclaimed the judgment of the Lord against unbelief in order that the church "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_6"
    }
  }, [_vm._v("of God may be planted and built for those who were destroyed, dragged down and lost (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). Those chosen by God to proclaim his word were set apart by special revelation (G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AZIANZUS).")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-030"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_6"
    }
  }, [_vm._v("1:6 "), _c('i', [_vm._v("Only a Youth")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_6"
    }
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ID ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CT ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDEFULLY. ")])]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USEBIUS OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESAREA: ")]), _vm._v("The Hebrew Scripture introduces Moses at first as declining the leadership of the people by what he said to God who conversed with him: “I beg you, O Lord, appoint someone else who is able, whom you will send.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN33",
      "id": "ap_NFIN33-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Afterwards it portrays Saul as hiding himself to avoid assuming the kingdom and the prophet Jeremiah as humbly declining his mission."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN34",
      "id": "ap_NFIN34-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REPARATION FOR THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL 12.9.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN35",
      "id": "ap_NFIN35-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH, ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES, ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESISTED THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALL.")])]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AZIANZUS:")]), _vm._v(" I resort once again to history. When I consider the men of best repute in ancient days, who were ever preferred by grace to the office of ruler or prophet, I discover that some readily complied with the call while others deprecated the gift. I also learn that those who drew back were not blamed for their timidity, nor were those who came forward accused of being too eager. The former stood in awe of the greatness of the ministry; the latter trustfully obeyed him who called them. Aaron was eager, but Moses resisted;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN36",
      "id": "ap_NFIN36-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Isaiah readily submitted,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN37",
      "id": "ap_NFIN37-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" but Jeremiah was afraid of his youth and did not venture to prophesy until he had received from God a promise and a power beyond his years. I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFENSE OF ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIGHT TO ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTUS, ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RATION 2.114.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN38",
      "id": "ap_NFIN38-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODEST ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALL.")])]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AZIANZUS:")]), _vm._v(" It is a good thing even to hold back from God for a little while—as did the great Moses in ancient times,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN39",
      "id": "ap_NFIN39-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" and Jeremiah later on—and then to run readily to him when he calls. This is what Aaron"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN40",
      "id": "ap_NFIN40-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" and Isaiah"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN41",
      "id": "ap_NFIN41-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" did—as long as both are done with a respectful spirit. Do the former because you lack strength. Do the latter because of the power of God who calls you. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTER AND ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELUCTANCE, ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RATION 1.1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN42",
      "id": "ap_NFIN42-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODESTY OR ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VOIDANCE? ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE: ")]), _vm._v("Both Moses and Jeremiah, chosen by the Lord to declare the words of God to the people, avoided through modesty that which through grace they could do. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTIES OF THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LERGY 1.17.66.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN43",
      "id": "ap_NFIN43-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIVILEGE AND ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEDOM OF ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLING. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Prophets had power either to speak or to refrain from speaking. They were not bound by necessity but were honored with a privilege. For this reason Jonah fled, for this reason Ezekiel delayed and for this reason Jeremiah excused himself. And God drives them not only by compulsion but also by advising, exhorting, threatening. He does not darken their mind, because to cause distraction, madness and great darkness is the proper work of a demon. It is God’s work to illuminate and with consideration to teach what is necessary. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON 1 ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 29.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN44",
      "id": "ap_NFIN44-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URDEN OF THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE: ")]), _vm._v("But perhaps you may say, How does Jeremiah call the yoke heavy, when the Lord in the Gospel has said, “For my yoke is easy, and my burden is light”?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN45",
      "id": "ap_NFIN45-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Now, first understand that the Greek has “yoke” only, and has not added “heavy.” Notice this, also, that although it was so in Lamentations, in the Gospel he said “easy yoke” and “light burden,” not “light yoke.” For the yoke of the Word can be heavy, yet easy. Heavy to the youth, heavy to the young man whose age is in fuller flower, so that he is unwilling to offer the neck of his mind in subjection to the yoke of the Word. The yoke of the Word can seem heavy because of the burdens of discipline, the rigor of improvement, the weight of abstinence and the curbing of lust. Yet it is easy because of the "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_7"
    }
  }, [_vm._v("fruitfulness of grace, the hope of eternal reward and the sweetness of a purer conscience. Still, he called the yoke of the Word “easy” and the burden of conscience “light,” because for him who has taken up the yoke of the Word with a patient neck the burden of discipline cannot be heavy. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSOLATION ON THE ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EATH OF ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPEROR ")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALENTINIAN 11.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN46",
      "id": "ap_NFIN46-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-031"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:7-8 "), _c('i', [_vm._v("Do Not Be Afraid to Be Sent")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PECIAL ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALL. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("We do not find, therefore, that the expression “to be sent from God” is be used of anyone other than the saints. It occurs in the case of Isaiah . . . and in the case of Jeremiah, “You shall go to all that I shall send you”; and in the case of Ezekiel, “I send you to the people of Israel, to a nation of rebels, who have rebelled against me.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN47",
      "id": "ap_NFIN47-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 2.184.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN48",
      "id": "ap_NFIN48-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REED TO ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERCOME ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIBULATIONS. ")])]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME: ")]), _vm._v("You should not consider the matter of age, he said, for you have learned through another prophet’s words that “a man’s gray hair is his wisdom.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN49",
      "id": "ap_NFIN49-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" May you only be willing to continue, for you will have me as a companion by whose assistance you will accomplish everything: “Open your mouth, and I will fill it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN50",
      "id": "ap_NFIN50-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Neither should you consider the number of those against whom you are about to speak, but consider me only, who is with you to deliver you, says the Lord. The Lord delivers, however, not so that the prophet will be free of persecutions and difficulties, for we read that he was severely afflicted. Instead, the Lord liberates one who suffers everything to overcome these tribulations rather than yielding to them. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IX ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS ON ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH 1.4.1-2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN51",
      "id": "ap_NFIN51-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-032"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:9 "), _c('i', [_vm._v("The Touch of God’s Word")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S AS ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRE. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("In sacred language God is called a fire. For instance, Scripture says, “Our God is a consuming fire.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN52",
      "id": "ap_NFIN52-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" It also speaks as follows concerning the substance of the angels when it says, “He makes his angels spirits and his ministers a burning fire.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN53",
      "id": "ap_NFIN53-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" In another place, “The angel of the Lord appeared in a flame of fire in the bush.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN54",
      "id": "ap_NFIN54-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" We have, moreover, received a commandment to be “fervent in spirit,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN55",
      "id": "ap_NFIN55-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" which undoubtedly means that the Word of God is hot and fiery. The prophet Jeremiah also hears from him who gave him his answer, “Behold, I have put my words into your mouth like a fire.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN56",
      "id": "ap_NFIN56-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Since God, then, is a fire, and the angels a flame of fire and all the saints are fervent in spirit, so, on the contrary, those who have fallen away from the love of God are undoubtedly said to have cooled in their affection for him and to have become cold. For the Lord also says that “because iniquity has grown, the love of many will grow cold.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN57",
      "id": "ap_NFIN57-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINCIPLES 2.8.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN58",
      "id": "ap_NFIN58-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDS ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTER THE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHET’S ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUTH. ")])]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTULLIAN: ")]), _vm._v("The Scripture narrative goes on to explain in a popular manner that “they did not understand that he spoke to them about the Father,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN59",
      "id": "ap_NFIN59-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" although they ought certainly to have known that the Father’s words were uttered in the Son because they read in Jeremiah, “And the Lord said to me, ‘Behold, I have put my words in your mouth.’” A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GAINST ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAXEAS 22.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN60",
      "id": "ap_NFIN60-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSPIRATION. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("I say this, for Isaiah said, “The Lord has given me a learned tongue that I should know when I ought to speak a word.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN61",
      "id": "ap_NFIN61-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Furthermore, what of Jeremiah? When he was sent, he then was inspired by God. And what of Ezekiel? For, when he had eaten the chapter of the book, he then spoke prophetically. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 69.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN62",
      "id": "ap_NFIN62-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_8"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHETS ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERVE THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH. ")])]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOPHILUS OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA: ")]), _vm._v("The Lord has said to his prophet, “See, I have this day set you over the nations and over the kingdoms to root out and to pull down and to destroy and . . . to build and to plant.” In every age he bestows the same grace on his church, that his body may be preserved intact and that the poison of heretical opinions may nowhere prevail over it. And now also do we see the words fulfilled. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER 90, ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIPHANIUS.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN63",
      "id": "ap_NFIN63-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROVIDES THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDS. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("We pray that words may be given us, as it is written in the book of Jeremiah that the Lord said to the prophet: “Behold, I have put my words in your mouth as fire. See, I have set you this day over the nations, and over the kingdoms, to root out and to pull down, and to destroy, and to throw down, and to build and to plant.” A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GAINST ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELSUS 4.1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN64",
      "id": "ap_NFIN64-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-033"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:10 "), _c('i', [_vm._v("Destroying and Rebuilding")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULTIVATION OF ")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRTUE. ")])]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASSIAN: ")]), _vm._v("But you should know that we must work twice as hard to drive out vice as we do to acquire virtue. And this is not simply our own opinion, but we were instructed by the opinion of the One who alone knows the strength and the method of his work: “See,” he says, “I have set you this day over nations and over kingdoms, to pluck up and to break down, to destroy and to overthrow, to build and to plant.” He points out that four things are required for getting rid of poisonous elements: to root up, to pull down, to waste and to destroy. But in order to do good and acquire righteousness, all that is required is to build and to plant. It is perfectly evident that it is a harder thing to tear up and eradicate the ingrained passions of body and soul than to introduce and plant spiritual virtues. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFERENCE 2.14.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN65",
      "id": "ap_NFIN65-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AW-")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REACHING. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("For unless there were some who were destroyed to be rebuilt, Jeremiah would not have written, “See, I have this day set you to throw down and to build.” E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITIONS OF THE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS 89.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN66",
      "id": "ap_NFIN66-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOUNCES ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDGMENT ON ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NBELIEF. ")])]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME: ")]), _vm._v("It is important to observe here that two joys succeed four sorrows. The good cannot be built up unless the evil is destroyed, nor can the best be planted unless the worst is eradicated. For “every plant that the heavenly Father has not planted will be uprooted,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN67",
      "id": "ap_NFIN67-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" and every building that does not have its foundation on rock but was built on sand is undermined and destroyed by the word of God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN68",
      "id": "ap_NFIN68-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" But that which Jesus will consume by the breath of his mouth and destroy by the coming of his presence,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN69",
      "id": "ap_NFIN69-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" indeed, all sacrilege and perverse doctrine, he will annihilate forever. Furthermore, he will depose and scatter all who elevate themselves against the knowledge of God, trusting instead in their own wisdom, which is foolishness to God,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN70",
      "id": "ap_NFIN70-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" so that the lower dwellings may be prepared for them and that those who are conformed to the truth of the church, having previously been destroyed and plucked up, might be planted and established in the higher places, such that what the apostle said will be fulfilled: “You are God’s edifice, God’s field.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN71",
      "id": "ap_NFIN71-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Many people understand this passage to refer to the person of Christ. For the name Jeremiah means “the heights of the Lord,” the Lord who destroyed the kingdoms of the devil, who had shown them to him on a high mountain,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN72",
      "id": "ap_NFIN72-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" and destroyed the adversarial powers as well, canceling the bond of errors on the cross."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN73",
      "id": "ap_NFIN73-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" It is also said in the Psalms concerning these things, after the figurative truth of history: “Why do nations murmur and the people meditate in vain? The kings of the earth stand by and the princes convene as one.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN74",
      "id": "ap_NFIN74-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" The church of God is planted and built for those who were plucked up, destroyed, dragged down and lost. But about the person of "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_9"
    }
  }, [_vm._v("Jeremiah, there is no doubt, for we read subsequently that he took a chalice full of wine and all the nations were commanded to drink.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN75",
      "id": "ap_NFIN75-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IX ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS ON ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH 1.6.1-5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN76",
      "id": "ap_NFIN76-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POKESMEN ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANCTIFIED. ")])]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AZIANZUS: ")]), _vm._v("Isaiah, again, beheld the glory of the seraphim, and after him Jeremiah, who was entrusted with great power against nations and kings. The one heard the divine voice and was cleansed by a live coal for his prophetic office, and the other was known before his formation and sanctified before his birth. Paul, also, while yet a persecutor, who became the great herald of the truth and teacher of the Gentiles in faith,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN77",
      "id": "ap_NFIN77-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" was surrounded by a light"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN78",
      "id": "ap_NFIN78-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" and acknowledged him whom he was persecuting, and was entrusted with his great ministry and filled every ear and mind with the gospel. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EATH OF ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHER, ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RATION 18.14.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN79",
      "id": "ap_NFIN79-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa1e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap2.vue
// module id = 84
// module chunks = 0